import { Denounce } from './../../../core/models/denounce.model';
import { Action, createReducer, on } from '@ngrx/store';
import * as fromComplaintsActions from './complaints.actions';

export const complaintsFeatureKey = 'complaints';

export interface ComplaintsState {
	complaintsPerPeriod: any;
	complaints: Denounce[];
	lastUpdate: Date;
	loading: boolean;
	busLines: any;
	error: boolean;
	sse: EventSource | null;
}

export const initialState: ComplaintsState = {
	complaintsPerPeriod: [],
	complaints: [],
	busLines: [],
	lastUpdate: null,
	loading: true,
	error: false,
	sse: null,
};

export const reducer = createReducer(
	initialState,
	on(fromComplaintsActions.loadComplaints, (state) => ({
		...state,
		// loading: true,
	})),
	on(fromComplaintsActions.loadComplaintsSuccess, (state, { complaints }) => ({
		...state,
		complaints,
		loading: false,
		error: false,
		lastUpdate: new Date(),
	})),
	on(fromComplaintsActions.loadComplaintsFailure, (state) => ({
		...state,
		loading: false,
		error: true,
	})),
	on(
		fromComplaintsActions.loadComplaintsPerPeriodSuccess,
		(state, { complaints }) => ({
			...state,
			complaintsPerPeriod: complaints,
		})
	),
	on(
		fromComplaintsActions.loadPartialComplaintsPerPeriodSuccess,
		(state, { complaints }) => ({
			...state,
			complaints: [...complaints, ...state.complaints],
			lastUpdate: new Date(),
		})
	),
	on(fromComplaintsActions.loadBusLinesSuccess, (state, { busLines }) => ({
		...state,
		busLines,
	})),
	on(fromComplaintsActions.connectSseSuccess, (state, { sse }) => ({
		...state,
		sse,
	})),
	on(fromComplaintsActions.addNewComplaintSuccess, (state, { complaint }) => ({
		...state,
		complaints: [complaint, ...state.complaints],
	}))
);

export function complaintsReducer(
	state: ComplaintsState,
	action: Action
): ComplaintsState {
	return reducer(state, action);
}
